<template>
    <div>
        <a-row type="flex" justify="end" class="mb-15">

            <!-- --------------------
                  COlUMN FILTER
            --------------------- -->
            <a-dropdown v-model="visibleDropdown">
                <a-button icon="eye" class="mr-1">{{ lang.watch.columns }}</a-button>
                <a-menu slot="overlay">
                    <a-menu-item  v-for="(field, key) in fields" :key="key">
                        <a-checkbox v-model="columns[key]" :value="field.dataIndex">
                            {{ field.title }} <a-icon v-show="!columns[key]" type="eye-invisible" />
                        </a-checkbox>
                    </a-menu-item>
                </a-menu>
            </a-dropdown>

            <!-- --------------------
                  HELP BUTTON
            --------------------- -->
            <a-popover placement="left" trigger="click">
                <template #content>
                    <p>
                        <a-badge status="processing" /> Puede presionar el boton
                        <a-button
                            icon="plus-circle"
                            shape="circle"
                            type="link"
                            size="small" /> para agregar un elemento al pedido.
                    </p>
                </template>
                <template #title>
                    <span>Ayuda</span>
                </template>
                <a-button shape="circle" icon="question"></a-button>
            </a-popover>
        </a-row>

        <a-config-provider>
            <template v-slot:renderEmpty>
                <div style="text-align: center">
<!--                    <a-icon type="smile" style="font-size: 20px" />-->
<!--                    <p>Data Not Found</p>-->
                </div>
            </template>
            <!-- --------------------
                   TABLE START
            --------------------- -->
            <a-table
                size="middle"
                bordered
                :columns="fields.filter((field, key) => columns[key])"
                :data-source="paginated.data"
                :loading="isLoading"
                :pagination="paginated"
                :row-key="(record, index) => index"
                :scroll="{ y: 700, x: 1800 }"
                :custom-row="customRow"
                @change="handleFetchWithOrder">
                <template #title>
                    <a-row type="flex" align="middle" justify="space-between">
                        <a-col>
                            <h2 class="mb-0">{{ lang.watch.title }}</h2>
                        </a-col>
                        <a-col>
                            <a-row type="flex" align="middle" :gutter="8">
                                <a-col class="my-sm-2 w-sm-100p">
                                    <strong>{{ lang.watch.search_by }}:</strong>
                                </a-col>

                                <a-col class="my-sm-2 w-sm-100p">
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>
                                                Puedes usar comodines (*) para mejorar tus busquedas
                                            </span>
                                        </template>
                                        <a-input-search
                                            ref="watch-search"
                                            :placeholder="lang.watch.watch"
                                            v-model="search.watch"
                                            @search="getWatches({ name: $event, page: 1 }).then(() => clearSearch('part'))"
                                            enter-button/>
                                    </a-tooltip>
                                </a-col>
                                <a-col class="my-sm-2 w-sm-100p">
                                    <a-tooltip placement="top">
                                        <template slot="title">
                                            <span>
                                                Puedes usar comodines (*) para mejorar tus busquedas
                                            </span>
                                        </template>
                                        <a-input-search
                                            ref="part-search"
                                            v-model="search.part"
                                            :placeholder="lang.watch.part_placeholder"
                                            @search="getPart({ part: $event, page: 1 }).then(() => clearSearch('watch'))"
                                            enter-button/>
                                    </a-tooltip>
                                </a-col>
                                <a-col class="my-sm-2 w-sm-100p">
                                    <a-button block @click="fetchWatches({ force: true })">
                                        {{ lang.watch.refresh }}
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </template>

                <!-- --------------------
                      PICTURE FIELD
                --------------------- -->
                <template #picture="item">
                    <span @click.stop.prevent>
                        <a-popover placement="right">
                            <template #content>
                                <img
                                    :alt="imageForItemWithDimensions(item, '128x128')"
                                    @error="handle"
                                    :src="imageForItemWithDimensions(item, '128x128')"
                                    style="width: 128px; height: 128px; border-radius: 16px;"/>
                            </template>
                                <img
                                    :alt="imageForItemWithDimensions(item, '128x128')"
                                    @error="handle"
                                    :src="imageForItemWithDimensions(item, '32x32')"
                                    style="width: 32px; height: 32px; border-radius: 16px;"/>
                        </a-popover>

                    </span>
                </template>

                <!--
                  this loop renders all the cells
                  except for picture and url in order
                  to print a parsed version of the data
                -->
                <template v-for="(field, key) in fields.filter(f => f.dataIndex !== 'picture' || f.dataIndex !== 'url')" #[field.dataIndex]="item, source">
                    <span :key="key" >
                        <template v-if="totalInCartByItem(item) && !loggedUserIsAdmin && existsDuplicatedInCart(item, source).isOriginal">
                            <br/>

                            <template>
                                <template v-if="item">
                                    {{ item }}
                                </template>
                                <template v-else>
                                    <span>Sin datos</span>
                                </template>
                                <span @click.stop>
                                    <item-counter-charger tabindex="0"  @click.stop
                                    removable
                                    :value="totalInCartByItem(item)"
                                    @keyup="setQuantityForItem({ item, quantity: $event })"
                                    @blur="setQuantityForItem({ item, quantity: $event })"
                                    @increment="incrementPartQuantity(indexForFoundPartInCart(item))"
                                    @decrement="decrementPartQuantity(indexForFoundPartInCart(item))"
                                    @remove="removeFromCart(indexForFoundPartInCart(item))"/>
                                </span>
                            </template>
                        </template>
                        <template v-else>
                            <span @click.stop>
                                <a-button
                                    icon="plus-circle"
                                    shape="circle"
                                    type="link"
                                    size="small"
                                    :disabled="totalInCartByItem(item) > 0"
                                    v-if="shouldShowAddButton(item, field, source)"
                                    @click="addToCart({ part: item, field: field.dataIndex, watch: source.name, reference: source.reference, case_f: source.case_f, source })" />
                            </span>
                            <template v-if="item">
                                {{ item }}
                            </template>
                            <template v-else>
                                <span>Sin datos</span>
                            </template>
                        </template>

                    </span>
                </template>

                <template #empty>
                    Empty
                </template>
            </a-table>
        </a-config-provider>

        <!-- --------------------
               DRAWER START
        --------------------- -->
        <a-drawer
            :title="`Reloj: ${getWatchName()}`"
            width="40%"
            placement="right"
            :closable="true"
            @close="handleDrawer()"
            :visible="drawer.visibility">
            <div>
                <a-spin :spinning="isLoading">

                    <div class="d-flex justify-content-start">
                        <img
                            :alt="imageForItemWithDimensions(selectedWatch, '128x128')"
                            @error="handle"
                            :src="imageForItemWithDimensions(selectedWatch, '128x128')"
                            class="watch-drawer-img m-2 d-block">
                    </div>

                    <a-collapse class="custom-collapsible" accordion>
                        <template v-for="(field, key) in isLoading ? [] : modalFields">
                            <a-collapse-panel
                                v-if="shouldShowCollapsibleHeader(field)"
                                :header="collapsibleHeader(field)"
                                :key="key">

                                <ul style="list-style: none;">
                                    <li v-for="(_part, key) in partsForWatch(field)" :key="key">
                                        <template v-if="totalInCartByItem(_part[field.dataIndex]) && !loggedUserIsAdmin">
                                            <b>{{ _part[field.dataIndex] }}</b>
                                            <br/>
                                            <item-counter-charger
                                                removable
                                                :value="totalInCartByItem(_part[field.dataIndex])"
                                                @keyup="setQuantityForItem({ item: _part[field.dataIndex], quantity: $event })"
                                                @increment="incrementPartQuantity(indexForFoundPartInCart(_part[field.dataIndex]))"
                                                @decrement="decrementPartQuantity(indexForFoundPartInCart(_part[field.dataIndex]))"
                                                @remove="removeFromCart(indexForFoundPartInCart(_part[field.dataIndex]))"/>
                                        </template>
                                        <template v-else>
                                            <a-button
                                                icon="plus-circle"
                                                shape="circle"
                                                type="link"
                                                size="small"
                                                v-if="shouldShowAddButton(_part[field.dataIndex], field, true)"
                                                @click="addToCart({ part: _part[field.dataIndex], field: field.dataIndex, watch: _part.watch, reference: _part.reference, casef: _part.casef })" />
                                            <b>{{ _part[field.dataIndex] || '-- No encontrado --' }}</b>
                                        </template>
                                    </li>
                                </ul>
                            </a-collapse-panel>
                        </template>
                    </a-collapse>
                </a-spin>
            </div>
        </a-drawer>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import unknown_file from '@/assets/unknown_file.png';
import { URL } from '@/constants';

export default {
    name: "app",
    data: () => ({
        watch: '',
        part: '',
        search: {
            watch: '',
            part: ''
        },
        currentPage: 1,
        visibleDropdown: false,
        columns: [],
        defaultImage: unknown_file,
        drawer: {
            visibility: false,
        },
        baseImagePath: `${URL}/images`
    }),
    computed: {
        ...mapState({
            paginated: state => state.watch.paginated,
            isLoading: state => state.watch.isLoading,
            selectedWatch: state => state.watch.parts,
            cart: state => state.watch.cart,
        }),
        ...mapGetters({
            lang: 'lang',
            fields: 'watch/fields',
            modalFields: `watch/modalFields`,
            totalInCartByItem: `watch/totalInCartByItem`,
            loggedUserIsAdmin: 'session/loggedUserIsAdmin',
            indexForFoundPartInCart: `watch/indexForFoundPartInCart`,
            partsForWatch: `watch/partsForWatch`
        })
    },
    methods: {
        ...mapActions({
            fetchWatches: 'watch/fetch',
            getWatchDetails: 'watch/getWatchDetails',
            getPart: 'watch/getPart',
            getWatches: 'watch/getWatches',
            addToCart: 'watch/addToCart',
            incrementPartQuantity: 'watch/incrementPartQuantity',
            decrementPartQuantity: 'watch/decrementPartQuantity',
            setQuantityForItem: 'watch/setQuantityForItem',
            removeFromCart: 'watch/removeFromCart'
        }),
        ...mapMutations({
          setWatch: 'watch/SET_WATCH'
        }),
        /**
         *
         * @param {{ current, total, perPage }} pagination
         * @param {[*]} filters
         * @param {{ order, sort }} sorter
         */
        handleFetchWithOrder(pagination, filters, sorter) {
            this.fetchWatches({ page: pagination.current, force: true, sorter })
        },

        getWatchName() {
            const found = this.paginated.data.find(it => it.watch_id === this.selectedWatch.watch_id)
            if (found) {
                return found.name
            }

            return ""
        },

        clearSearch(type) {
            this.search[type] = ''
        },

        /**
         *
         * @param {object} watch
         */
        fetch(watch) {
            this.setWatch({ parts: [] })
            this.getWatchDetails({ watch, force: false })
        },

        /**
         *
         * @param {object|null} item
         * @param {{ dataIndex, key }} field
         * @param {{ watch_id }|null} source
         * @returns {boolean|*|boolean}
         */
        shouldShowAddButton(item, field, source = null) {
          // console.log(item, source.watch_id)

            const key = field.key || field.dataIndex

            if (item) {
              let text = item.trim().toLowerCase();
              return !this.loggedUserIsAdmin && (
                text !== `#n/a`
                && text !== `nil`
                && text !== `=na()`
                && text !== '#N/A'
                && key !== 'picture'
                && key !== 'watch'
                && key !== 'url'
                && key !== 'name'
                && key !== '#N/A'
                && key !== 'case_f'
                && key !== 'mark_name'
                && key !== 'family_name'
              )
            }

            return false
        },
        existsDuplicatedInCart (item, source) {
          return {
            isOriginal: this.cart.some($0 => $0.name === item && $0.watch_id === source.watch_id),
            value: item
          }
        },

        /**
         *
         * @param {object|null} watch
         */
        handleDrawer(watch = null) {
            this.setWatch({ parts: [] })
            this.drawer.visibility = watch !== null;

            if (watch) {
                this.fetch(watch)
            }
        },

        /**
         *
         * @param {object} watch
         * @returns {{style: {cursor: string}, on: {click: (function(): void)}}}
         */
        customRow(watch) {
            return {
                on: {
                    click: () => this.handleDrawer(watch)
                },
                style: {
                    cursor: 'pointer'
                }
            }
        },

        /**
         *
         * @param {{ title, key, dataIndex }} field
         * @returns {string}
         */
        collapsibleHeader(field) {

            const fieldTitle = field.title;
            const fieldItemsLength = this.partsForWatch(field).length;
            // console.log(this.partsForWatch(field), field)
            const fieldItemsString = this.partsForWatch(field).map($0 => $0[field.dataIndex]).join(', ');
            return `${fieldTitle} (${fieldItemsLength}): ${fieldItemsString}`;
        },

        imageForItemWithDimensions(item, dimmensions) {
            let dir = 'watches/images'
            let url = URL
            if (process.env.VUE_APP_STORAGE_DIRECTION === 'spaces') {
                dir = 'images'
                url = process.env.VUE_APP_SPACES_URL
            }

            return `${url}/${dir}/${item.reference}/${dimmensions}_${item.name}.jpg`

            // let picture_urls = item.picture_urls

            // try {
            //     picture_urls = typeof picture_urls === 'string' ? JSON.parse(picture_urls) : picture_urls
            // } catch(el) {
            //     picture_urls = {}
            // }

            // return picture_urls?.[dimmensions] ?? ''
        },

        /**
         *
         * @param {string} field
         * @returns {boolean}
         */
        shouldShowCollapsibleHeader(field) {
            return this.modalFields.some(() => {
                return this.partsForWatch(field).some(p => {
                    return p.name
                })
            })
        },

        toggleVisible() {
            this.visibleDropdown = !this.visibleDropdown
        },

        handle(e) {
            e.target.src = unknown_file
        },
    },
    mounted() {
        // this.fetchWatches({ force: false, page: this.$route.query.page });
        this.columns = this.fields.filter(f => f.dataIndex !== 'url').map(() => true);
    },
};
</script>

<style scoped lang="scss">

    $delay: .2s;

    .image__item {
        cursor: pointer;
        transition: transform $delay linear;

        &:hover {
            transform: scale(3);
            transition: transform $delay linear;
        }
    }

    .watch-description-activator {
        color: cornflowerblue;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }

    .watch-drawer-img {
        width: 128px;
        height: 128px;
    }
</style>
